import React, { useEffect, useState } from "react";
import { ROUTES } from "../utils/Routes";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Button from "../ui/Button";
import Space from "../ui/Space";
import Label from "../ui/Label";

export default function DocumentationController(props) {


    const { controller = "", callback = () => { } } = props;

    const [selected, setSelected] = useState(); 
    const route = ROUTES.GLOBAL.DOCS;

    useEffect(() => {
        window.bm_state.value = route
        const cleanup = listen(controller, route, [{ key: KBD.ESCAPE, action: () => callback() },]);
        return cleanup;
    }, [])

    const components = [
        { id: "button", title: "Button" },
        { id: "label", title: "Label" },
        { id: "usage", title: "Usage" },
        { id: "faq", title: "FAQ" },
        { id: "contact", title: "Contact" },
    ];


    const drawMenu = () => {
        return components.map(item => {
            return (<Button style={{ "width": "200px" }}>{item.title}</Button>)
        })
    }

    const drawContent = () => {

        return (
            <div>
                <Space>
                    <pre><small>{"<Label>Primary</Label>"}</small></pre>
                    <Button type="primary">Primary</Button>
                    <Button type="secondary">Secondary</Button>
                    <Button type="danger">Danger</Button>
                    <Button>Default</Button>
                    <Button disabled type="primary">Disabled</Button>
                    <div style={{"width" : "500px"}}>
                        <Button block type="primary">Block</Button>
                    </div>
                </Space>
            </div>
        )
    }


    return (
        <div style={{ "width": "100%" }}>
            <div style={{ "height": "60px" }} />
            <div style={{ "display": "flex", "padding": "20px" }}>
                <div style={{ "backgroundColor": "var(--card-bg)", "padding": "20px" }} >
                    <Space flexDirection="column">
                        {drawMenu()}
                    </Space>
                </div>
                <div style={{ "backgroundColor": "var(--console-bg)", "width": "100%", "padding": "20px" }}>
                    {drawContent()}
                </div>
            </div>
        </div>
    )
}